// avatar-upload-tools.js
import Axios from 'axios';
import Cropper from 'cropperjs'

;(async ({ $, $$, log, getTranslation}) => {
    const translation = await getTranslation('avatar-upload-tools')

    const dropAreaHighlightClass = 'avatar-upload-tools__drop-area--highlight'
    const stepHiddenClass = 'avatar-upload-tools__step--hidden'
    const errorHiddenClass = 'avatar-upload-tools__error--hidden'

    const cropperOptions = {
        viewMode: 1,
        initialAspectRatio: 1,
        aspectRatio: 1,
        responsive: true,
        scalable: false,
        zoomOnTouch: false,
        zoomOnWheel: false,
        autoCropArea: 1
    }

    $$('.avatar-upload-tools').forEach(au => {
        const dropArea = au.querySelector('.avatar-upload-tools__drop-area')
        const inputFile = au.querySelector('.avatar-upload-tools__input')
        const cropButton = au.querySelector('.avatar-upload-tools__crop-button')
        const cancelButton = au.querySelector('.avatar-upload-tools__cancel-button')
        const targetImages = $$(`.${au.dataset.targetClass}`)

        const step1 = au.querySelector('.avatar-upload-tools__step-1')
        const step2 = au.querySelector('.avatar-upload-tools__step-2')
        const errorEl = au.querySelector('.avatar-upload-tools__error')

        if (
            !dropArea ||
            !inputFile ||
            !cropButton ||
            !cancelButton ||
            !step1 ||
            !step2 ||
            !errorEl
        ) {
            return
        }

        let cropper = null
        const cropperImg = au.querySelector('.avatar-upload-tools__cropper-img') 

        /**
         * upload via drag & drop
         */
        // prevent all default events and bubbling
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false)
        })

        // highlight
        ;['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false)
        })
          
        // unhighlight
        ;['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false)
        })

        dropArea.addEventListener('drop', handleDrop, false)

        function handleDrop(e) {
            const dt = e.dataTransfer
            const file = dt.files[0]

            handleFile(file)
        }

        // Upload via input
        inputFile.addEventListener('change', e => {
            const file = e.target.files[0]
            handleFile(file)
        })

        cropButton.addEventListener('click', async () => {
            // Crop
            const croppedCanvas = cropper.getCroppedCanvas()

            // Round
            const roundedCanvas = getRoundedCanvas(croppedCanvas)

            const imgUrl = roundedCanvas.toDataURL()
            const rawImageData = await fetch(imgUrl)
            const blob = await rawImageData.blob()
            const imageFile = new File([blob], 'croppedImage', { type: 'image/png' })

            const formData = new FormData()
            formData.append('image', imageFile)
            
            const API = au.dataset.api

            try {
                const response = await Axios.post(API, formData)
                // console.log(response)
    
                targetImages.forEach(image => image.src = response.data.image_link)
                CNS.$fns.closeAvatarUploadModal()
                resetTools()
            } catch (error) {
                const msg = error.response.data.message
                resetTools()
                showError(msg)
            }
            
        })

        cancelButton.addEventListener('click', resetTools)

        resetTools()

        function highlight(e) {
            dropArea.classList.add(dropAreaHighlightClass)
        }
    
        function unhighlight(e) {
            dropArea.classList.remove(dropAreaHighlightClass)
        }

        function resetTools() {
            dropArea.classList.remove(dropAreaHighlightClass)
            inputFile.value = ''
            if (cropper) {
                cropper.destroy()
            }
            step2.classList.add(stepHiddenClass)
            step1.classList.remove(stepHiddenClass)
            hideError()
            unhighlight()
        }

        function hideError() {
            errorEl.classList.add(errorHiddenClass)
            errorEl.innerHTML = ''
        }

        function showError(msg) {
            errorEl.innerHTML = msg
            errorEl.classList.remove(errorHiddenClass) 
        }

        function goStep2() {
            step2.classList.remove(stepHiddenClass)
            step1.classList.add(stepHiddenClass)
        }

        function getRoundedCanvas(sourceCanvas) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = sourceCanvas.width;
            const height = sourceCanvas.height;
      
            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
          }

        function handleFile(file) {
            // log('file', file)
            if (!['image/jpeg', 'image/png'].includes(file.type)) {
                showError(translation.errors['file-type-invalid'])
                return
            }

            hideError()

            const reader = new FileReader()
            reader.addEventListener('load', event => {
                let img = document.createElement('img')
                img.setAttribute('src', event.target.result)
                imagePrev.innerHTML = ''
                imagePrev.append(img)
            })

            cropperImg.src = URL.createObjectURL(file)
            
            if (cropper) {
                // console.log(cropper)
                cropper.destroy()
            }

            cropper = new Cropper(cropperImg, cropperOptions)
            goStep2()
        }
    })

    function preventDefaults (e) {
        e.preventDefault()
        e.stopPropagation()
    }
})(CNS);